/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Care_Log_Activity_TypeInputs */

const vi_care_log_activity_type = /** @type {(inputs: Care_Log_Activity_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loại hoạt động`)
};

/**

* @param {Care_Log_Activity_TypeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const care_log_activity_type = /** @type {((inputs?: Care_Log_Activity_TypeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Care_Log_Activity_TypeInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_care_log_activity_type(inputs)
});